import { HStack } from '@chakra-ui/react';
import React from 'react';
import ProfileDropdownMenu from '../../ProfileDropdownMenu';
import NotificationsBell from '../../NotificationsBell';

interface Props {
  isTransparent: boolean;
}

const DefaultHeader = ({ isTransparent }: Props) => {
  return (
    <HStack>
      <NotificationsBell />
      <ProfileDropdownMenu isHeaderTransparent={isTransparent} />
    </HStack>
  );
};

export default DefaultHeader;
